<template>
    <div class="forsakringsbolag">
        <admin-lock-border />
        <div class="header">
            <h1>Försäkringsbolag</h1>
            <CustomButton type="button" variant="hollow" @click="openCreateForsakringsbolag">
                <img src="@/assets/plus_circle_blue.svg" />
                <span>Skapa nytt försäkringsbolag</span>
            </CustomButton>
        </div>

        <kliniken-table
            v-if="forsakringsbolag.results"
            :items="forsakringsbolag.results"
            paginationStyle="paging"
            :columns="columns"
            :count="count"
            :limit="limit"
            :currentPage="currentPage"
            @loadPage="loadPage"
            @changeLimit="changeLimit"
            @loadMore="loadMore"
            :showBottom="true"
            :showLimitDropdown="true"
            :has-dropdown="true"
            :dropdown-actions="dropdownActions"
            @editForsakringsbolag="editForsakringsbolagFromTable"
        />
    </div>
</template>

<script>
    import tabIcon from "@/assets/gear.svg";
    import ForsakringsbolagForm from "./ForsakringsbolagForm.vue";

    export default {
        name: "ForsakringsbolagList",
        tabName: "Försäkringsbolag",
        icon: tabIcon,
    };
</script>

<script setup>
    import { onMounted, ref, onBeforeUnmount } from "vue";
    import emitter from "tiny-emitter/instance";
    import { openDialog } from "@/utils";
    import AdminLockBorder from "@/components/AdminLockBorder.vue";
    import { getConfig, klinikenApi } from "@/api";
    import KlinikenTable from "@/components/Table/KlinikenTable.vue";
    import CustomButton from "@/components/Button.vue";
    import store from "@/store";

    const forsakringsbolag = ref([]);
    const count = ref(0);
    const columns = ref([
        {
            title: "Namn",
            name: "namn",
        },
        {
            title: "Ordning",
            name: "ordning",
        },
    ]);
    const dropdownActions = ref([
        {
            name: "editForsakringsbolag",
            title: "Redigera försäkringsbolag",
            show: () => true,
        },
    ]);

    const limit = ref(50);
    const offset = ref(0);
    const fetchBatch = ref(1);
    const params = ref({});
    const currentPage = ref(1);

    const loadPage = async (page) => {
        currentPage.value = page;
        offset.value = (page - 1) * limit.value;
        await fetchForsakringsbolag();
    };

    const loadMore = async () => {
        fetchBatch.value++;
        await fetchForsakringsbolag();
    };

    const changeLimit = async (dropdownLimit) => {
        fetchBatch.value = 1;
        limit.value = dropdownLimit;
        await fetchForsakringsbolag();
    };

    const fetchForsakringsbolag = async () => {
        params.value = { ...params.value, limit: limit.value, offset: offset.value };
        if (limit.value > 0) {
            params.value["limit"] = limit.value * fetchBatch.value;
        }
        try {
            const response = await klinikenApi.get(
                "/core/forsakringsbolag/",
                getConfig({ params: { ...params.value } })
            );
            forsakringsbolag.value = response.data;
            count.value = response.data.count;
        } catch (error) {
            openDialog("Kunde inte hämta försäkringsbolag.", "warning");
        }
    };

    const openCreateForsakringsbolag = () => {
        store.dispatch("tabs/openTab", {
            component: ForsakringsbolagForm,
            parameters: { redigera: false },
        });
    };

    const editForsakringsbolagFromTable = (forsakringsbolag) => {
        store.dispatch("tabs/openTab", {
            component: ForsakringsbolagForm,
            parameters: {
                redigera: true,
                forsakringsbolag,
            },
        });
    };

    onMounted(async () => {
        await fetchForsakringsbolag();
        emitter.on("refreshForsakringsbolag", fetchForsakringsbolag);
    });

    onBeforeUnmount(() => {
        emitter.off("refreshForsakringsbolag", fetchForsakringsbolag);
    });
</script>
<style lang="scss">
    .forsakringsbolag {
        .header {
            h1 {
                margin: 0;
            }

            display: flex;
            gap: 20px;
            align-items: center;
        }
    }
</style>
